<template>
  <div class="flex-column gap8">
    <label class="textBold"
      >{{ field.label }}
      <span
        v-if="isRequired"
        class="bold"
        style="color: var(--systemError)"
        >*</span
      ></label
    >

    <div
      class="question-container"
      :class="{ 'question-container-3cols': field.inputValues.length > 2 }"
    >
      <div
        v-for="inputValue in field.inputValues"
        :key="inputValue.id"
        class="flex-column"
        @click="setSelection(inputValue)"
      >
        <!--Icon style-->
        <div
          v-if="inputValue.labelIcon"
          class="answer-tile"
          :class="{ 'answer-tile--active': selectedValue === inputValue.value }"
        >
          <FontAwesomeIcon
            :icon="inputValue.labelIcon"
            size="2x"
          />
          <div class="flex-row align-items-center grow">
            {{ inputValue.text }}
          </div>
        </div>

        <!--Radio style-->

        <label
          v-if="!inputValue.labelIcon"
          class="answer-tile__radio"
          :class="{
            'answer-tile__radio--active': selectedValue === inputValue.value,
          }"
        >
          <span class="checkmark noShrink" />
          <span>{{ inputValue.text }}</span>
          <input
            :id="inputValue.id"
            v-model="selectedValue"
            :value="inputValue.value"
            type="radio"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useBnplApplicationStore } from "~/stores/bnplapplication";
import { mapStores } from "pinia";

export default {
  name: "ApplicationRadioQuestion",
  components: { FontAwesomeIcon },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: null,
      default: undefined,
    },
    isRequired: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ["input"],
  data() {
    return {
      selectedValue: null,
    };
  },
  computed: {
    ...mapStores(useBnplApplicationStore),
  },
  mounted() {
    if (this.value === undefined) {
      this.selectedValue =
        this.bnplApplicationStore.getFlowQuestionAnswer(
          this.field.identifier
        ) || null;
    } else {
      this.selectedValue = this.value;
    }
    this.$watch("selectedValue", this.valueWatcher);
  },
  methods: {
    valueWatcher() {
      this.$emit("input", this.selectedValue);
      /*
      this.bnplApplicationStore.saveDynamicData({
        key: this.field.identifier,
        value: this.selectedValue,
      });
      */
    },
    setSelection(inputValue) {
      this.selectedValue = inputValue.value;
    },
  },
};
</script>

<style scoped>
.answer-tile {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border: 1px solid white;
  text-align: center;
  background: white;
  border-radius: 8px;
  padding: 24px 16px;
  overflow: hidden;
  word-break: break-word;
  height: 100%;
  transition: all 0.1s;
}

.answer-tile--active {
  border-color: var(--systemSuccess);
  font-weight: 700;
  color: var(--brandPrimary);
}

.answer-tile__radio {
  cursor: pointer;
  border: 1px solid white;
  display: flex;
  justify-content: center;
  gap: 8px;
  position: relative;
  background: white;
  border-radius: 8px;
  padding: 32px 16px;
  overflow: hidden;
  word-break: break-word;
  text-align: center;
  transition: all 0.1s;
  flex-grow: 1;
  align-items: center;
}

.answer-tile__radio--active {
  border-color: var(--systemSuccess);
}

.answer-tile__radio--active > .checkmark {
  border-color: var(--brandPrimary);
}

.answer-tile__radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: relative;
  display: block;
  height: 18px;
  width: 18px;
  border: 2px solid var(--gray400);
  border-radius: 50%;
}

.answer-tile__radio > .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkmark:after {
  top: 50%;
  left: 50%;
  margin: -5px 0 0 -5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--brandPrimary);
}

.answer-tile__radio--active > .checkmark:after {
  display: block;
}

.answer-tile__radio:hover {
  border-color: var(--brandPrimary);
}

.question-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8px 24px;
  justify-items: stretch;
  align-items: stretch;
}

.question-container-3cols {
  grid-template-columns: repeat(3, 1fr);
}

@media only screen and (max-width: 792px) {
  .question-container-3cols {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
